//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

import { LocalizationHelper, MapHelper } from '../../../helpers'

import { IMRBaseControlController } from '../base'
import { MapOptions, Map, MapLegendItem } from '../map2/map.directive.controller'

import { IIMRDepositoryParameters, IMRDepositoryParametersOptions } from './depository-parameters.interfaces'
import { OpLocation, OpView, OpViewColumn } from '../../../models/core'
import { UserSessionService } from '../../../services/user-session'
import { MapService } from '../map2'
import { Enums } from '../../../models/common'
import { OpMarker } from '../../../models/custom'


export class IMRDepositoryParametersController
    extends
    IMRBaseControlController<IIMRDepositoryParameters, IMRDepositoryParametersOptions>
    implements
    IIMRDepositoryParameters {

    //#region members

    public hasLocation: boolean
    public isLoading: boolean
    public noAssignedDepositoryText: string

    private map: Map

    //#endregion


    //#region Ctor

    constructor(private mapService: MapService, private userSessionService: UserSessionService) {
        super()
    }

    //#endregion


    //#region Component

    protected initialize(options: IMRDepositoryParametersOptions): JQueryPromise<void> {
        this.isLoading = true
        this.hasLocation = options.depository != null

        return this.getLocationView()
            .then((locationView: OpView) => {
                this.initializeText()

                if (this.hasLocation) {
                    return $.when(
                        this.initializeMap(locationView, options.depository),
                        this.initializeDepositoryParameters(options.depository)
                    )
                }
            })
            .then(() => {
                this.isLoading = false
            })
    }

    //#endregion

    //#region IIMRDepositoryParameters implementation

    public refresh(): void {
        if (this.map != null) {
            this.map.resize()
        }
    }
    //#endregion


    //#region IIMRConfirmationPopup Implementation

    //#endregion


    //#region Location parameters

    public parametersFormOptions: DevExpress.ui.dxFormOptions

    private initializeDepositoryParameters(depository: OpLocation): void {
        this.parametersFormOptions = {
            formData: this.getDepositoryParametersFormData(depository),
            items: this.getDepositoryParametersFormItems(),
            colCountByScreen: {
                lg: 2,
                md: 2,
                sm: 2,
                xs: 1
            },
            alignItemLabels: true,
            labelLocation: "top",
            readOnly: true
        }
    }

    private getDepositoryParametersFormData(depository: OpLocation): any {
        const formData = {
            name: null,
            address: null
        }

        let name: any = null
        let zip: any = null
        let city: any = null
        let address: any = null

        _.forEach(depository.dynamicValues, dv => {
            const idDataType = OpViewColumn.getColumnIdDataType(dv.Key)

            switch (idDataType) {
                case Enums.DataType.LOCATION_NAME:
                    name = dv.Value
                    break

                case Enums.DataType.LOCATION_ZIP:
                    zip = dv.Value
                    break

                case Enums.DataType.LOCATION_CITY:
                    city = dv.Value
                    break

                case Enums.DataType.LOCATION_ADDRESS:
                    address = dv.Value
                    break
            }
        })

        if (name == null) {
            name = depository.name
        }

        if (city == null) {
            city = depository.city
        }

        if (address == null) {
            address = depository.address
        }

        formData.name = name

        if (zip && city && address) {
            formData.address = zip + ' ' + city + ', ' + address
        }

        if (!zip && !city && !address) {
            formData.address = ''
        }

        if (zip && city && !address) {
            formData.address = zip + ' ' + city
        }

        if (zip && !city && address) {
            formData.address = zip + ', ' + address
        }

        if (zip && !city && !address) {
            formData.address = zip
        }

        if (!zip && city && address) {
            formData.address = city + ', ' + address
        }

        if (!zip && city && !address) {
            formData.address = city
        }

        if (!zip && !city && address) {
            formData.address = address
        }

        return formData
    }

    private getDepositoryParametersFormItems(): DevExpress.ui.dxFormSimpleItem[] {
        const items: DevExpress.ui.dxFormSimpleItem[] = []

        items.push({
            dataField: "name",
            editorType: "dxTextBox",

            label: {
                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Name)
            },
        })
        items.push({
            dataField: "address",
            editorType: "dxTextBox",

            label: {
                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Address)
            },
        })

        return items
    }

    //#endregion


    //#region Map

    public mapOptions: MapOptions

    private initializeMap(locationView: OpView, depository: OpLocation): JQueryPromise<void> {
        const deferred: JQueryDeferred<void> = $.Deferred<void>()

        MapHelper
            .getDefaultOptions(this.userSessionService.getDataProvider())
            .then((mapOptions: MapOptions) => {
                mapOptions.hideCloseButton = true
                mapOptions.hideCounter = true

                mapOptions.onMapInit = (map: Map) => {
                    this.map = map

                    const marker: OpMarker = this.mapService.createOpMarker(depository, {
                        view: locationView
                    })

                    if (marker != null) {
                        map.setMarkers([marker], false, true)
                    }

                    deferred.resolve()
                }

                MapHelper.getLegendItems(this.userSessionService.getDataProvider(), Enums.ReferenceType.IdLocation)
                    .then((items: MapLegendItem[]) => {
                        mapOptions.legendItems = items
                    })
                    .always(() => {
                        this.mapOptions = mapOptions
                    })
            })

        return deferred.promise()
    }

    //#endregion


    //#region View

    private getLocationView(): JQueryPromise<OpView> {
        return this.userSessionService.getDataProvider().View.getActiveView(Enums.ReferenceType.IdLocation)
    }

    //#endregion


    //#region Text

    private initializeText(): void {
        this.noAssignedDepositoryText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoAssignedDepository)
    }

    //#endregion
}
